<template>
    <card-list>
        <subheader-list-item icon="fa-align-left" title="Plan Information"/>
        <container-list-item padded>
            <div class="columns">
                <div class="column">
                    <b-field label="Total" label-position="inside">
                        <b-input v-model="plan.total" placeholder="0.00"></b-input>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Deposit" label-position="inside">
                        <b-input v-model="plan.down" placeholder="0.00"></b-input>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Total Paid" label-position="inside">
                        <b-input v-model="plan.paid" placeholder="0.00"></b-input>
                    </b-field>
                </div>
            </div>
        </container-list-item>
    </card-list>
</template>

<script>
    import CardList from "../../TIER/components/CardList";
    import SubheaderListItem from "../../TIER/components/SubheaderListItem";
    import ContainerListItem from "../../TIER/components/ContainerListItem";

    export default {
        name: 'PaymentPlanForm',
        props: {
            plan: {
                type: Object,
                required: true
            }
        },
        components: {ContainerListItem, SubheaderListItem, CardList}
    };

</script>

<style scoped>

</style>
